import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Box, Progress } from "@chakra-ui/react";

ChartJS.register(ArcElement, Tooltip, Legend);

export const InscriptionPercent = ({ dispo, notDispo }) => {
  const data = {
    labels: ["disponible", "non disponible"],
    datasets: [
      {
        label: "# of Votes",
        data: [dispo, notDispo],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const color = "#3385ff";

  return (
    <Box style={{ width: "90%", background: "white" }}>
      <Progress
        value={(notDispo / (dispo + notDispo)) * 100}
        size="sm"
        bg="#F1404B"
        colorScheme="blue"
        isAnimated
        borderRadius={40}
        hasStripe
        alignItems={"left"}
      />
      <Box position={"relative"} top={"-4"} right={"55px"}>
        {new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 2 }).format(
          (notDispo / (dispo + notDispo)) * 100
        )}
        %
      </Box>
    </Box>
  );
  return <Doughnut data={data} />;
};

export default InscriptionPercent;
